export default __webpack_public_path__ + "static/media/Communication.caba3317.svg";